import Vue from "vue"
import vueResource from "vue-resource"
Vue.use(vueResource)
// 请求url			'http://127.0.0.1:5000'		'https://truckapi.f.yizuo.ltd'
import {API_URL} from '../baseurl'
let baseUrl = API_URL
// Vue.http.options.emulateJSON = true;
//设置使用json数据发送
Vue.http.options.emulateJSON = false;
let token = ''
if(localStorage.getItem('userInfo')){
     try {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          token = (userInfo && userInfo.token) || ''
     } catch(e) {
          console.error('Failed to parse userInfo:', e)
          token = ''
     }
}

Vue.http.interceptors.push((request, next) => {
  request.headers.set('token',token)
  next((response) => {
    if (!response) {
    }
    return response;
  });
});
export default {
  get(url) {
    return new Promise((resolve, reject) => {
      Vue.http.get(
        baseUrl + url,
      )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  jsonp(url) {
    return new Promise((resolve, reject) => {
      Vue.http.jsonp(
        baseUrl + url,
      )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  put(url,params) {
    return new Promise((resolve, reject) => {
      Vue.http.put(
        baseUrl + url,
        params
      )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  post(url, params,headers) {
    return new Promise((resolve, reject) => {
      Vue.http.post(
        baseUrl + url,
        params,
       
          // {emulateJSON: true}
      ).then(res => {
        resolve(res)
      }).catch((err) => {
        reject(err);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/router/vue-resource.js